/* eslint-disable no-underscore-dangle */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect, useCallback } from 'react';
import { string } from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import debounce from 'lodash/debounce';
import client from '../../../../api/api';
import CSS from './gas-order-styles';

const GenerateGasOrder = ({ shipmentId }) => {
  const [gasStationSelected, setGasStationSelected] = useState({});
  const [carrierId, setCarrierId] = useState();
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [errorMsg, setErrorMsg] = useState('');
  const [creatingGasOrder, setCreatingGasOrder] = useState(false);
  const [success, setSuccess] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const loading = open && options.length === 0;

  // Carga inicial de Datos del Transportista.-
  const fetchCarrierUserData = useCallback(async () => {
    try {
      const { data } = await client.endpoints.carrier.getUserData();
      setCarrierId(data.CarrierDetails[0].id);
    } catch (error) {
      console.error(error);
      setErrorMsg('Error al obtener información del transportista');
    }
  }, []);

  useEffect(() => {
    if (shipmentId) {
      fetchCarrierUserData();
    }
  }, [shipmentId, fetchCarrierUserData]);

  const getGasStationsDelayed = useCallback(
    debounce(
      async (text, callback) => {
        setOptions([]);
        const { data } = await client.endpoints.generic.getEnabledGasStationList(text);
        callback(data.docs.map(({ id, name: gasStationName }) => ({ gasStationName, id })));
      },
      200,
      { leanding: true }
    ),
    []
  );

  useEffect(() => {
    if (inputValue)
      getGasStationsDelayed(inputValue, filteredOptions => {
        setOptions(filteredOptions);
      });
  }, [inputValue, getGasStationsDelayed]);

  const createGasOrder = async () => {
    try {
      setCreatingGasOrder(true);
      const gasOrder = {
        gasStationId: gasStationSelected.id,
        handmade: false,
      };
      const res = await client.endpoints.carrier.createGasOrder(carrierId, shipmentId, gasOrder);
      if (res.status === 201) {
        setCreatingGasOrder(false);
        setSuccess(true);
      }
    } catch (error) {
      console.error(error);
      setCreatingGasOrder(false);
      setErrorMsg(error.response.data);
    }
  };

  return (
    <CSS.GasOrderWrap>
      <h3>Crear orden de gasoil</h3>
      <Autocomplete
        id="asynchronous-demo"
        style={{ width: 300 }}
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        getOptionLabel={option => {
          setGasStationSelected(option);
          return option.gasStationName;
        }}
        options={options}
        filterOptions={x => x}
        onInputChange={(e, newInputValue) => setInputValue(newInputValue)}
        loading={loading}
        renderInput={params => (
          <TextField
            {...params}
            label="Estaciones de servicio"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
      <span className="create-btn-wrap">
        {!creatingGasOrder && !success ? (
          <button className="create-btn" type="button" onClick={() => createGasOrder()}>
            Crear orden
          </button>
        ) : (
          <>
            {success ? (
              <img src="/images/icons/done.png" alt="done" />
            ) : (
              <CircularProgress style={{ color: '#ffbb0f' }} />
            )}
          </>
        )}
      </span>
      {errorMsg ? <p className="error">{errorMsg}</p> : ''}
    </CSS.GasOrderWrap>
  );
};

GenerateGasOrder.propTypes = {
  shipmentId: string.isRequired,
};

export default GenerateGasOrder;
